import React from "react";

export const SummitLoader = ({ size = 56, label }) => (
  <div className="flex flex-col items-center gap-2" data-testid="summit-loader">
    <style>{`@keyframes sa-fill{0%{clip-path:inset(100% 0 0 0)}70%{clip-path:inset(0 0 0 0)}100%{clip-path:inset(0 0 0 0)}}`}</style>
    <div className="relative" style={{ width: size, height: size }}>
      <img src="/media/sa-logo.png" alt="" className="absolute inset-0 w-full h-full object-contain opacity-20 grayscale" />
      <img src="/media/sa-logo.png" alt="" className="absolute inset-0 w-full h-full object-contain" style={{ animation: "sa-fill 1.6s ease-in-out infinite" }} />
    </div>
    {label && <span className="font-mono text-[10px] uppercase tracking-widest text-gray-500">{label}</span>}
  </div>
);
